import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChevronLeft = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.507 2.447a.75.75 0 0 1 .046 1.06L7.766 12l7.787 8.493a.75.75 0 0 1-1.106 1.014l-7.801-8.508a1.4 1.4 0 0 1-.293-.458A1.47 1.47 0 0 1 6.646 11l7.801-8.508a.75.75 0 0 1 1.06-.046"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChevronLeft;
